import type { FulfillmentMode, OrderItem } from '../types';

/**
 * TCR-629: chỉ hàng QUANTITY (không serial) ở luồng INSTANT mới chọn được kho
 * xuất — hàng serial-tracked lấy kho theo serial, PREORDER không xuất kho ngay.
 */
export function canPickWarehouse(
  item: Pick<OrderItem, 'trackingMode' | 'specificationCode'>,
  fulfillmentMode: FulfillmentMode,
): boolean {
  return (
    fulfillmentMode !== 'PREORDER' &&
    item.trackingMode === 'quantity' &&
    !item.specificationCode
  );
}
